<template >
    <el-dialog id="top_card" :visible.sync="visible" title="人员信息" width="30%" center append-to-body>
        <el-card class="box-card">
            <div class="text item">
                个人信息
            </div>
            <div class="text item">
                <el-row>
                    <el-col :span="12">
                        <el-image
                                style="width: 100px; height: 100px"
                                :src="userinfo.image"
                                fit="fill"></el-image>
                    </el-col>
                    <el-col :span="12">
                        <el-row>
                            <el-col :span="24">
                                {{userinfo.username}}
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                {{userinfo.xm}}
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                {{userinfo.sjhm}}
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                {{userinfo.bmmc}}
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-card>

        <el-card class="box-card">
            <div class="text item">
                岗位信息
            </div>
            <div class="text item">
                <el-row v-for="(item,index) in usergd" style="margin-top: 10px;margin-bottom: 10px">
                    <el-col :span="24">
                        {{item.gdmc}}
                    </el-col>
                    <el-col  :span="8" v-for="(item1,index1) in item.tBcxxes" >
                        <div v-if="item1.bclx =='1'">早班</div>
                        <div v-else-if="item1.bclx=='2'">中班</div>
                        <div v-else-if="item1.bclx=='3'">晚班</div>
                        <div>{{item1.sbsj}}-{{item1.xbsj}}</div>
                    </el-col>
                </el-row>

            </div>
        </el-card>
    </el-dialog>
</template>

<script>


    export default {
        data () {
            return {
                visible: false,
                userid:'',
                userinfo: {},
                usergd:[],
                userBm:{}
            }
        },
        created () {

        },
        methods: {
            init (id) {
                if(id){
                    this.userid =id
                    this.visible = true
                    this.userinfo={}
                    this.usergd =[]
                    this.userBm ={}
                    this.$nextTick(() =>{

                        this.$request.get('/bjba/yhgl/getglxx2', {
                            params: {
                                userid: this.userid
                            }
                        }).then(res => {
                            this.userinfo = res.data.user
                            this.usergd = res.data.gd;
                            this.userBm = res.data.bm
                        })
                    })
                }
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
